
import React from 'react'
import PropTypes from 'prop-types'

import MessageDisplayArea from '../../../../_dependencies/js_chat_clients/module/dev/room/message-display-area/MessageDisplayArea.jsx'
import { createMessage } from '../../../../_dependencies/js_chat_clients/module/dev/room/message-display-area/messages/messageHelpers.js'
import { textDisplayTemplate } from '../../../../_dependencies/js_chat_clients/operator/dev/src/libs/store/middleware/rooms/messages.js'
import '../../../../_dependencies/js_chat_clients/module/dev/room/message-display-area/MessageDisplayArea_operator.scss'
import './MessageDisplayAreaWrapper.scss'

const MessageDisplayAreaWrapper = ({ transcript, messageDisplayAreaRef }) => {
  if (!transcript || !transcript.messages) return null

  const messages = transcript.messages.map((message, ii) => createMessage({
    ...message,
    id: ii,
    nickname: message.authorName,
    date: message.created,
    type: message.authorName === 'System' ? 'system' : 'visitor',
    subtype: 'info',
    clientTimestamp: Date.now() + ii,
    isFake: false,
    translatedTextHtml: message.translatedText,
    visitorServerUrl: 'https://messenger.providesupport.com',
    textDisplayTemplate,
    // authorId
    // modCount
  }))

  /* TODO: костыль, убрать когда пофиксят бэкенд */
  for (let ii = 0; ii < messages.length; ii++) {
    if (messages[ii].text.indexOf('/file-transfer/') !== -1) {
      messages[ii].text = messages[ii].text.replace(/<a(.{0,}">)/, '<a style="cursor: not-allowed;" title="Transferred files are not available in the transcripts app">')
    }
  }

  return (
    <MessageDisplayArea
      messages={messages}
      typings={[]}
      messageViewType="a"
      fileMessageText={{}}
        // ref={messageDisplayAreaRef => { this.messageDisplayAreaRef = messageDisplayAreaRef; }}
      options={{
        showTime: true,
        // fileTransfer: {
        //   chash: session.companyIdHash,
        //   fileTransferSessionId: room.fileTransferSessionId,
        //   nickName: session.operatorLogin,
        //   connectionId: network.connectionId,
        // },
        displaySpinner: true,
        displayTypings: true,
        displayTypingsSmile: true,
        initialScrollTop: 0,
        customScrollTop: 0,
        // nickname: session.nickname,
        roomId: transcript.transcriptId,
        // draftUnreadMessages: room.draftUnreadMessages,
      }}
      texts={{}}
      operatorsImgParams={{}}
      saveDraftUnreadMessages={() => {}}
      onScroll={() => {}}
      onRemoveMessage={() => {}}
      onUnmount={() => {}}
      ref={messageDisplayAreaRef}
    />
  )
}

MessageDisplayAreaWrapper.propTypes = {
  transcript: PropTypes.object.isRequired,
  messageDisplayAreaRef: PropTypes.any,
};

export default MessageDisplayAreaWrapper
